import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { cn } from "@/lib/utils";

type LogoVariant = "auto" | "light" | "dark";

interface LogoProps {
  className?: string;
  variant?: LogoVariant;
}

export const Logo = ({ className, variant = "auto" }: LogoProps) => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const themeToUse: "light" | "dark" =
    variant === "auto"
      ? (resolvedTheme as "light" | "dark" | undefined) ?? "dark"
      : variant;

  const logoSrc = themeToUse === "dark" ? "/logo/dark.svg" : "/logo/light.svg";

  return (
    <span className="flex items-center gap-2">
      <img
        src={mounted ? logoSrc : "/logo/dark.svg"}
        alt="Arcitext"
        className={cn("h-8 w-auto", className)}
        loading="lazy"
      />
      <span className="text-xl font-bold">Arcitext</span>
    </span>
  );
};

export default Logo;
